import React from "react";
import { Table } from "antd";

type DetailItem = {
  cost_category: string;
  amount: number;
};

type GroupedData = {
  name: string;
  detail: DetailItem[];
};

type Props = {
  data: GroupedData[];
};

const GroupedTable: React.FC<Props> = ({ data }) => {
  // Chuyển đổi data thành mảng phẳng và thêm rowSpan cho tên
  const transformedData = data.flatMap((item, groupIndex) =>
    item.detail.map((detail, index) => ({
      key: `${groupIndex}-${index}`,
      name: item.name,
      cost_category: detail.cost_category,
      amount: detail.amount,
      rowSpan: index === 0 ? item.detail.length : 0,
    }))
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (_: any, row: any) => {
        if (row.rowSpan === 0) {
          return {
            children: null,
            props: { rowSpan: 0 },
          };
        }
        return {
          children: row.name,
          props: { rowSpan: row.rowSpan },
        };
      },
    },
    {
      title: "Cost Category",
      dataIndex: "cost_category",
    },
    {
      title: "Amount (USD)",
      dataIndex: "amount",
      align: "center",
    },
  ] as any;

  return (
    <Table
      columns={columns}
      dataSource={transformedData}
      pagination={false}
      className="rs-table table-text-nowrap match-height"
    />
  );
};

export default GroupedTable;
